import './SubHeader.css';

interface HeaderProps {
  children?: string;
}

function SubHeader({ children }: HeaderProps): JSX.Element {
  return <h3 className="sub-header">{children}</h3>;
}

export default SubHeader;
